module.exports = __webpack_public_path__ + "media/images/icons/web-a53d82918e5174221ce48033ea78f409.svg";